export default class ErrorWithStatus extends Error {
  public readonly statusCode: number = 0
}
